import { uploadFile } from '../utils/file_upload';
import { removeFile } from '../utils/file_remove';

const UPLOAD_FILE = 'UPLOAD_FILE';
const FILE_UPLOADED = 'FILE_UPLOADED';
const REMOVE_FILE = 'REMOVE_FILE';
const FILE_REMOVED = 'FILE_REMOVED';
const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';
const FILE_REMOVE_ERROR = 'FILE_REMOVE_ERROR';

const events = [
  UPLOAD_FILE,
  FILE_UPLOADED,
  REMOVE_FILE,
  FILE_REMOVED,
  FILE_UPLOAD_ERROR,
  FILE_REMOVE_ERROR,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(UPLOAD_FILE, ({ id, values, csrfToken, uploadEndpoint }) => {
    uploadFile({
      values,
      csrfToken,
      uploadEndpoint,
      onResponse: ({ status, data }) => {
        if (status === 200) {
          EVENT_BUS.dispatch(FILE_UPLOADED, { id, ...data });
        }
      },
      onError: (err) => {
        const { message } = err.response.data;
        EVENT_BUS.dispatch(FILE_UPLOAD_ERROR, { id, message });
      },
    });
  });

  EVENT_BUS.on(REMOVE_FILE, ({ id, csrfToken, removeEndpoint }) => {
    removeFile({
      id,
      csrfToken,
      removeEndpoint,
      onResponse: ({ status, data }) => {
        if (status === 200) {
          const { message } = data;
          EVENT_BUS.dispatch(FILE_REMOVED, { id, message });
        }
      },
      onError: (err) => {
        const { message } = err.response.data;
        EVENT_BUS.dispatch(FILE_REMOVE_ERROR, { id, message });
      },
    });
  });
};

export const UPLOADERS_EVENTS = {
  initializeEventListeners,
  UPLOAD_FILE,
  FILE_UPLOADED,
  REMOVE_FILE,
  FILE_REMOVED,
  FILE_UPLOAD_ERROR,
  FILE_REMOVE_ERROR,
};
